export default __webpack_public_path__ + "static/media/ecfoundation1.62f9a426.png";